import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { InputControlService } from '../../../core/services/input-control.service';
import { FilterForm } from '../../../author-dashboard/promo-wizard/filters-form';
import { ModalService } from '../../../core/services/modal.service';
import { GenreService } from '../../../core/services/data/genre.service';
import { PromoWizardService } from '../../../core/services/data/promo-wizard.service';
import { IPopulatedGenres } from '../../../types/populated';

import { IBook } from '../../../types/datatypes';

@Component({
	selector: 'app-filter',
	templateUrl: './filter.component.html',
	styleUrls: ['./filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class FilterComponent implements OnInit, OnDestroy {
	@Input() filterComponents: FilterForm;

	@Input() form: UntypedFormGroup;

	@Input() books: IBook[];

	@Output() advertQuery = new EventEmitter<any>();

	@Output() bookSelected = new EventEmitter<any>();

	public bookSelectionVisibleModal = false;

	public genreSelectionVisibleModal = false;

	public filteredBooks: IBook[] = [];

	public showBookSearch = false;

	public newBookVisibleModal = false;

	public selectedBook: IBook;

	public genres: string[] = [];

	public genresForm: UntypedFormGroup;

	public categories;

	public minimumStartDate = new Date();

	public defaultImageUrl = '../../../assets/img/defaults/default_book_image_400w_simple.jpg';

	private subscriptions$ = new Subscription();

	constructor(
		private modalService: ModalService,
		private genreService: GenreService,
		public promoWizardService: PromoWizardService,
	) {

	}

	ngOnInit(): void {
		this.subscriptions$.add(this.genreService.getGenres().subscribe((genres: IPopulatedGenres[]) => {
			const genresForm = {};
			const categories = genres.map((category) => {
				for (const { name } of genres) genresForm[name] = new UntypedFormControl(this.promoWizardService.genres.includes(name));
				genresForm[category.name] = new UntypedFormControl(this.promoWizardService.genres.includes(category.name));
				return category;
			});

			this.genresForm = new UntypedFormGroup(genresForm);
			this.categories = categories;
			this.filterComponents.promoPrice.value = this.promoWizardService.bookPromoPrice?.toString();
			this.filterComponents.promoStart.value = this.promoWizardService.startDate?.toString();
			this.filterComponents.promoEnd.value = this.promoWizardService.endDate?.toString();
			this.form = InputControlService.toFormGroup(this.filterComponents);
		}));
	}

	ngOnDestroy() {
		this.subscriptions$.unsubscribe();
	}

	toggleGenresModal() {
		this.genreSelectionVisibleModal = !this.genreSelectionVisibleModal;
		this.bookSelectionVisibleModal = false;

		// Only set genres if the modal is being closed
		if (!this.genreSelectionVisibleModal) {
			this.setGenres();
		}
	}

	displayNewBookModal() {
		this.modalService.open('add-book-form');
	}

	searchBooks() {
		const query = this.form.value.book;

		if (!query.length) {
			this.showBookSearch = false;
			return;
		}

		this.showBookSearch = true;
		this.filteredBooks = this.books.filter((book) => book.title.toLowerCase().includes(query.toLowerCase()));
	}

	selectBook(book) {
		this.promoWizardService.selectedBook = book;
		this.bookSelected.emit(book);
		this.showBookSearch = false;
		this.bookSelectionVisibleModal = false;
	}

	toggleBookSelection() {
		if (this.bookSelectionVisibleModal) {
			this.bookSelectionVisibleModal = false;
			return;
		}

		this.bookSelectionVisibleModal = true;
		if (this.promoWizardService.selectedBook) {
			this.filteredBooks = [this.promoWizardService.selectedBook];
			this.showBookSearch = true;
		}
	}

	setGenres() {
		this.promoWizardService.genres = Object.entries(this.genresForm.value)
			.filter(([key, value]) => value === true)
			.map(([key, value]) => key);
	}

	setStartDate(event) {
		this.promoWizardService.startDate = event;
	}

	setEndDate(event) {
		this.promoWizardService.endDate = event;
	}

	queryAdverts() {
		this.promoWizardService.bookPromoPrice = this.form.value.promo_price;

		if (this.promoWizardService.notReadyToQuery()) return;

		this.advertQuery.emit();
	}

	clearGenres() {
		this.genresForm.reset();
	}
}
